import React from 'react';
import PropTypes from 'prop-types';
import CalloutStyled from './callout.styled';

export const Callout = ({ className, text }) => {
  return (
    <CalloutStyled className={className}>
      <span>{text}</span>
    </CalloutStyled>
  )
}

Callout.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};
